import * as React from "react";
import { StyleProp, TextInput, ViewStyle } from "react-native";
import { useForm, Controller } from "react-hook-form";
import _ from "lodash";

import { Video } from "../../types";

import { Text, View } from "../../components/Themed";
import commonStyles from "../../styles/common";
import useAutosave from "../../common/hooks/useAutosave";

type VideoFormValues = Pick<Video, "url">;

export interface VideosFormProps {
  video?: Video;
  style?: StyleProp<ViewStyle>;
  onSave?: (values: VideoFormValues) => void;
  disabled?: boolean;
}

function VideoForm({
  video,
  style,
  onSave = _.noop,
  disabled,
}: VideosFormProps) {
  const { control, handleSubmit } = useForm<VideoFormValues>({
    defaultValues: video,
  });

  const save = useAutosave({
    onSave: handleSubmit(onSave),
  });

  return (
    <View style={style}>
      <Controller
        control={control}
        name="url"
        rules={{
          required: true,
        }}
        render={({ field: { onChange, onBlur, value } }) => (
          <>
            <TextInput
              editable={!disabled}
              style={commonStyles.textInput}
              placeholder="Vimeo Url"
              onBlur={onBlur}
              onChangeText={(text) => {
                onChange(text);
                save();
              }}
              value={value}
            />
          </>
        )}
      />
    </View>
  );
}

export default VideoForm;
